import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  margin-left: auto;
`

const Button = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  border: 1px solid var(--color-bg-sidebar);
  border-radius: 5px;
  background-color: var(--color-bg-sidebar);
  color: var(--color-text-primary);
  width: 80px;
  height: 32px;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:not(:last-child) {
    margin-right: 10px;
  }

  &:hover {
    color: var(--color-bg-main);
    background-color: var(--color-primary);
  }

  &:disabled {
    color: var(--color-text-disabled);
    cursor: default;
    background-color: var(--color-bg-sidebar);
    opacity: 0.5;
  }
`

const StyledPagination = styled.div`
  width: 100%;
  margin-top: 35px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--color-text-primary);
`

const Page = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-bg-sidebar);
  border-radius: 5px;
  color: ${p => (p.active ? 'var(--color-bg-main)' : 'var(--color-text-primary)')};
  background-color: ${p => (p.active ? 'var(--color-primary)' : 'var(--color-bg-sidebar)')};
  width: 22px;
  height: 22px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  ${p => !p.active && '&:hover { background-color: var(--color-secondary); color: var(--color-bg-main); }'}

  &:not(:last-child) {
    margin-right: 10px;
  }
`

const Ellipsis = styled.span`
  margin-right: 10px;
  color: var(--color-text-secondary);
`

const Pagination = ({
  paginate: { currentPage, pages, maxPage, next, prev, jump },
}) => {
  return (
    <StyledPagination>
      {pages.map(page => {
        if (page === '...') return <Ellipsis>{page}</Ellipsis>
        return (
          <Page
            key={page}
            active={currentPage === page}
            onClick={() => jump(page)}>
            {page}
          </Page>
        )
      })}
      <Row>
        <Button disabled={currentPage === 1} onClick={prev}>
          Previous
        </Button>
        <Button disabled={currentPage === maxPage} onClick={next}>
          Next
        </Button>
      </Row>
    </StyledPagination>
  )
}

export default Pagination
